module.exports = __webpack_public_path__ + "img/img_4850.f0f71e0d.png";